import { BaseDropdownOption } from '../../../common/Dropdown';
import {
  checkInQualityHref,
  checkInUsageHref,
} from '../../../constants/constants';

export const weekDropdownOptions = [
  {
    id: 'this_week',
    label: 'This Week',
    value: 'this_week',
  },
  {
    id: 'last_week',
    label: 'Last Week',
    value: 'last_week',
  },
];
export const monthDropdownOptions = [
  {
    id: 'this_month',
    label: 'This Month',
    value: 'this_month',
  },
  {
    id: 'last_month',
    label: 'Last Month',
    value: 'last_month',
  },
];

export const dayDropdownOptions = [
  {
    id: 'today',
    label: 'Today',
    value: 'today',
  },
  {
    id: 'yesterday',
    label: 'Yesterday',
    value: 'yesterday',
  },
];
export const getAnalyticsDropdownOptions = (
  href: string,
): BaseDropdownOption[] => {
  switch (href) {
    case checkInUsageHref:
      return [...weekDropdownOptions, ...monthDropdownOptions];
    case checkInQualityHref:
      return [...dayDropdownOptions, ...weekDropdownOptions];
    default:
      return [
        ...weekDropdownOptions,
        ...monthDropdownOptions,
        ...dayDropdownOptions,
      ];
  }
};

const teamColors = [
  {
    color_name: 'Light Sea Green',
    hex: '#20B2AA',
    rgb: 'rgb(32, 178, 170, 0.2)',
  },
  {
    color_name: 'Lime Green',
    hex: '#32CD32',
    rgb: 'rgb(50, 205, 50, 0.2)',
  },
  {
    color_name: 'Golden Yellow',
    hex: '#FFD700',
    rgb: 'rgb(255, 215, 0, 0.2)',
  },
  {
    color_name: 'Tomato Red',
    hex: '#FF6347',
    rgb: 'rgb(255, 99, 71, 0.2)',
  },
  {
    color_name: 'Deep Pink',
    hex: '#FF1493',
    rgb: 'rgb(255, 20, 147, 0.2)',
  },
  {
    color_name: 'Blue Violet',
    hex: '#8A2BE2',
    rgb: 'rgb(138, 43, 226, 0.2)',
  },
  {
    color_name: 'Sky Blue',
    hex: '#3CC3DF4D',
    rgb: 'rgb(60, 195, 223, 0.2)',
  },
  {
    color_name: 'Peach',
    hex: '#FF928A4D',
    rgb: 'rgb(255, 146, 138, 0.2)',
  },
  {
    color_name: 'Purple Blue',
    hex: '#8979FF4D',
    rgb: 'rgb(137, 121, 255, 0.2)',
  },
];

export const teamProperties = {
  AIM: {
    backgroundColor: teamColors[0].rgb,
    borderColor: teamColors[0].hex,
  },
  AIR: {
    backgroundColor: teamColors[1].rgb,
    borderColor: teamColors[1].hex,
  },
  APT: {
    backgroundColor: teamColors[2].rgb,
    borderColor: teamColors[2].hex,
  },
  'BC Experience': {
    backgroundColor: teamColors[3].rgb,
    borderColor: teamColors[3].hex,
  },
  CAMP: {
    backgroundColor: teamColors[4].rgb,
    borderColor: teamColors[4].hex,
  },
  COMS: {
    backgroundColor: teamColors[5].rgb,
    borderColor: teamColors[5].hex,
  },
  DICE: {
    backgroundColor: teamColors[6].rgb,
    borderColor: teamColors[6].hex,
  },
  PACT: {
    backgroundColor: teamColors[7].rgb,
    borderColor: teamColors[7].hex,
  },
  PRO: {
    backgroundColor: teamColors[8].rgb,
    borderColor: teamColors[8].hex,
  },
};

export const optionAll = { id: 'all', label: 'ALL', value: 'all' };

export const qualityToMissingQualityMap = {
  standard_format: 'Missing Standard',
  details: 'Missing Details',
};
